document.addEventListener("DOMContentLoaded", () => {

  const CLUB_CODES = ["TESTVEREIN"];

  const codeInput = document.getElementById("club-code");
  const applyBtn = document.getElementById("apply-club-code");
  const feedback = document.getElementById("club-feedback");

  if (!codeInput || !applyBtn || !feedback) return;

  let clubActive = false;

  function setVereinsdiscount(value) {
    const optionInputs = document.querySelectorAll(
      '[name="options[vereinsdiscount]"]'
    );

    if (!optionInputs.length) return false;

    optionInputs.forEach(input => {
      input.value = value;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    return true;
  }

  function setButtonInactive() {
    applyBtn.textContent = "Code anwenden";
    applyBtn.style.backgroundColor = "#e6e6e6";
    applyBtn.style.color = "#000";
    applyBtn.style.borderColor = "#ccc";
  }

  function setButtonActive() {
    applyBtn.textContent = "Code deaktivieren";
    applyBtn.style.backgroundColor = "#b6e3b6"; // dezentes Grün
    applyBtn.style.color = "#000";              // TEXT IMMER SCHWARZ
    applyBtn.style.borderColor = "#7fbf7f";
  }

  // Initialzustand
  setButtonInactive();

  applyBtn.addEventListener("click", () => {

    /* ===============================
       DEAKTIVIEREN
    =============================== */
    if (clubActive) {
      setVereinsdiscount("standard");

      clubActive = false;
      setButtonInactive();
      codeInput.disabled = false;

      feedback.textContent = "Vereinsrabatt deaktiviert";
      feedback.style.color = "inherit";

      return;
    }

    /* ===============================
       AKTIVIEREN
    =============================== */
    const code = codeInput.value.trim().toUpperCase();

    if (!CLUB_CODES.includes(code)) {
      feedback.textContent = "Ungültiger Vereinscode";
      feedback.style.color = "red";
      return;
    }

    const success = setVereinsdiscount("verein");

    if (!success) {
      feedback.textContent = "Vereinsrabatt nicht verfügbar";
      feedback.style.color = "red";
      return;
    }

    clubActive = true;
    setButtonActive();
    codeInput.disabled = true;

    feedback.textContent = "Vereinsrabatt aktiviert";
    feedback.style.color = "green";
  });

});
